import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('GameStore')
@observer
export default class GameStep2 extends Component {

    chooseNumber(number) {
        this.props.GameStore.setPlayers(number);
    }

    render() {

        const {
            players
        } = this.props.GameStore;

        const numberPlayers = players.length;

        return (
            <div className="step-2">
                <h1>Number Of Teams</h1>
                <div className="buttons">
                    <button
                        className={numberPlayers === 2 ?  " selected": ""}
                        onClick={this.chooseNumber.bind(this, 2)}>2</button>
                    <button
                        className={numberPlayers === 3 ?  " selected": ""}
                        onClick={this.chooseNumber.bind(this, 3)}>3</button>
                    <button
                        className={numberPlayers === 4 ?  " selected": ""}
                        onClick={this.chooseNumber.bind(this, 4)}>4</button>
                </div>
            </div>
        )
    }

};



// WEBPACK FOOTER //
// ./src/containers/Game/GameStep2.js